import { styled } from '@linaria/react';
import { semantic } from '../../theme/tokens';

export const SpinnerElement = styled.span<{ $size: number }>`
  display: inline-block;
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: voyager-spinner-spin 0.7s linear infinite;
  color: ${semantic.text.inverse};

  @keyframes voyager-spinner-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
